/// <amd-module name="Wiki/Clients/Search/RestClient/Search" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\wiki\vss-wiki-web\clients\search\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Search_Shared_Contracts from "Wiki/Clients/Search/Contracts/Search.Shared";

export interface ISearchRestClient extends IVssRestClient {
    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Wiki Search Request.
     * @param project - Project ID or project name
     */
    fetchWikiSearchResults(request: Search_Shared_Contracts.WikiSearchRequest, project?: string): Promise<Search_Shared_Contracts.WikiSearchResponse>;
}

class SearchRestClient extends RestClientBase implements ISearchRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Provides a set of results for the search request.
     * 
     * @param request - The Wiki Search Request.
     * @param project - Project ID or project name
     */
    public async fetchWikiSearchResults(
        request: Search_Shared_Contracts.WikiSearchRequest,
        project?: string
        ): Promise<Search_Shared_Contracts.WikiSearchResponse> {

        return this.beginRequest<Search_Shared_Contracts.WikiSearchResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/wikiSearchResults",
            routeValues: {
                project: project
            },
            body: request
        });
    }

}

export const SearchClientName = "TFS_WIKI_SEARCH.ISearchRestClient";

export function getSearchClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ISearchRestClient {
    return pageContext.getRestClient<ISearchRestClient>(SearchClientName, options);
}

RestClients.add(SearchClientName, { 
    factory: SearchRestClient,
    options: {
        serviceInstanceType: "00000010-0000-8888-8000-000000000000"
    }
});
